import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
import IMAPSecurityMechanism from 'owa-service/lib/contract/IMAPSecurityMechanism';

export let updateEditIncomingSecurity = mutatorAction(
    'updateEditIncomingSecurity',
    (incomingSecurity: IMAPSecurityMechanism) => {
        let store = connectedAccountsStore();
        store.editAccountState.incomingSecurity = incomingSecurity;
    }
);
